// ─────────────────────────────────────────────────────────────────────────────
// theme.js — EMRISK Design Tokens
// Fuente única de verdad para colores y tipografía.
// Importar en cualquier componente: import { C, FONTS, CHART_COLORS } from "./theme";
// ─────────────────────────────────────────────────────────────────────────────

// ── Paleta de colores ─────────────────────────────────────────────────────────
export const C = {
  // Fondos
  bg:       "#070c12",   // fondo principal de la app
  surface:  "#0d1520",   // paneles / sidebars
  card:     "#111b28",   // tarjetas / contenedores
  border:   "#1a2535",   // bordes y separadores

  // Textos
  text:     "#dde4ee",   // texto principal
  sub:      "#9ab4cc",   // texto secundario / valores
  muted:    "#8aa4b8",   // labels, hints
  dim:      "#556a7a",   // texto muy atenuado

  // Acento dorado (marca EMRISK)
  gold:     "#c8a96e",
  goldDim:  "#8a6d3b",
  goldGlow: "rgba(200,169,110,0.18)",

  // Semáforo funcional
  green:    "#34d399",
  red:      "#f87171",
  blue:     "#60a5fa",
  purple:   "#a78bfa",
  amber:    "#fbbf24",
  orange:   "#fb923c",
};

// ── Tipografía ────────────────────────────────────────────────────────────────
export const FONTS = {
  ui:   "monospace",                              // etiquetas, valores, código
  body: "'Segoe UI', system-ui, sans-serif",      // prosa, análisis, descripciones
};

// ── Colores para series de gráficas ──────────────────────────────────────────
export const CHART_COLORS = [
  C.gold,     // #c8a96e
  C.blue,     // #60a5fa
  C.green,    // #34d399
  C.red,      // #f87171
  C.purple,   // #a78bfa
  C.amber,    // #fbbf24
  C.orange,   // #fb923c
  "#2dd4bf",  // teal
  "#e879f9",  // pink
  "#38bdf8",  // sky
];

// ── Estilos Plotly (gráficas del agente) ─────────────────────────────────────
export const PLOTLY_BASE = {
  paper_bgcolor: "transparent",
  plot_bgcolor:  "transparent",
  font:          { color: C.muted, family: FONTS.ui, size: 13 },
  legend:        { orientation: "h", y: -0.25, font: { color: C.muted, size: 12 }, bgcolor: "transparent" },
  xaxis: {
    gridcolor: C.border, linecolor: C.border,
    tickfont:  { color: C.muted, size: 12 }, tickangle: -45,
  },
  yaxis: {
    gridcolor: C.border, linecolor: C.border,
    tickfont:  { color: C.muted, size: 12 },
  },
  hoverlabel: { bgcolor: C.card, bordercolor: C.border, font: { color: C.text, size: 13 } },
};

// ── CSS base para exports HTML ────────────────────────────────────────────────
export const HTML_EXPORT_CSS = `
  body { background: ${C.bg}; color: ${C.text}; font-family: ${FONTS.body}; padding: 30px; margin: 0; }
  h1, h2, h3 { color: ${C.gold}; font-family: ${FONTS.ui}; letter-spacing: 0.05em; }
  .card { background: ${C.card}; border: 1px solid ${C.border}; border-radius: 12px; padding: 20px; margin-bottom: 16px; }
  .label { color: ${C.gold}; font-size: 11px; text-transform: uppercase; letter-spacing: 1px; font-family: ${FONTS.ui}; }
  .value { color: ${C.text}; font-family: ${FONTS.ui}; }
  .muted { color: ${C.muted}; }
  .analysis-text { line-height: 1.7; color: ${C.sub}; font-size: 14px; font-family: ${FONTS.body}; }
  .analysis-text strong { color: ${C.gold}; }
  .footer { color: ${C.dim}; font-size: 10px; font-family: ${FONTS.ui}; margin-top: 32px; border-top: 1px solid ${C.border}; padding-top: 12px; }
  table { width: 100%; border-collapse: collapse; }
  th { color: ${C.gold}; font-family: ${FONTS.ui}; font-size: 10px; text-transform: uppercase; border-bottom: 1px solid ${C.border}; padding: 8px; text-align: left; }
  td { color: ${C.text}; font-family: ${FONTS.ui}; font-size: 12px; border-bottom: 1px solid ${C.border}; padding: 8px; }
`;
